import React, { useState, useCallback, useEffect, useRef } from "react";
import { FaCog } from "react-icons/fa";
import Declaration from "../../Components/Database/IngredientForm/Declaration"; // Your combined component
import Attributes from "../../Components/Database/IngredientForm/Attributes"; // Your combined component
import AllergenSelection from "../../Components/Database/IngredientForm/Allergens"; // New component
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Nutrition from "../../Components/Database/IngredientForm/Nutrition";
import ReactQuill from "react-quill";
import { TiTick } from "react-icons/ti";
import SymbolForm from "../../Components/Database/SymbolForm";
import { useModal } from "../../Hooks/modalContext";

const IngredientDBForm = () => {
  const [currentStep, setCurrentStep] = useState(1); // To track the pagination steps
  const [isInsertingSymbol, setIsInsertingSymbol] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false); // State for dropdown visibility
  const navigate = useNavigate();

  const [ingredients, setIngredients] = useState([
    { ingredientName: "", itemCode: "", vendorName: "", rmCode: "" },
  ]);
  const [existingIngredients, setExistingIngredients] = useState([]);
  const [sourceTypeOther, setSourceTypeOther] = useState(false);
  const [countryOther, setCountryOther] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  const [columnValues, setColumnValues] = useState({
    ing_item_code: "",
    rm_code: "",
    vegetarian: "",
    vegan: "",
    non_gmo: "",
    classification: "",
    gluten_status: "",
    bse_tse: "",
    // declared_allergen: '',
    // allergen_fermentation: '',
    residual_solvent: "",
    wada_compliance: "",
    eto_treated: "",
    irradiated: "",
    sewage_sludge_treated: "",
    pesticide: "",
    aflatoxin: "",
    preservative: "",
    antibiotic: "",
    gras: "",
    prop65_complaint: "",
  });

  const [attributeDetails, setAttributeDetails] = useState({
    "cas Number": "",
    "ec Number": "",
    "Source Type": "",
    source: "",
    country: "",
  });

  const [allergens, setAllergens] = useState({
    wheat: "",
    eggs: "",
    crustaceans_shell_fish: "",
    fish: "",
    milk: "",
    tree_nuts: "",
    peanuts: "",
    soy: "",
    sesame_seeds: "",
    celery: "",
    barley_oats_rye_spelt: "",
    orange_kiwi_peaches_apples: "",
    mushrooms: "",
    mustard: "",
    lupin: "",
    molluscs: "",
    sulfur: "",
  });

  // State for nutrition
  const [nutrition, setNutrition] = useState({
    calories: 0,
    fat: 0,
    carbohydrates: 0,
    protein: 0,
    moisture: 0,
    ash: 0,
  });

  //Symbol states
  const [symbolData, setSymbolData] = useState([]);
  const [selectedSymbols, setSelectedSymbols] = useState([
    { symbol: "0", symbol_code: "0000", symbol_id: 0 },
  ]);

  //Ingredient name state
  const [ingredientNameState, setIngredientNameState] = useState([]);

  useEffect(() => {
    const fetchExistingIngredient = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URI}/elixir/fetch_ingredient`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            withCredentials: true,
          }
        );

        if (res.status !== 200) {
          throw new Error("Failed to fetch ingredient details");
        }

        const details = res.data.data;

        const filteredDetails = details.map(
          ({ ing_item_code, ing_name, vendor, rm_code }) => ({
            ing_item_code,
            ing_name,
            vendor,
            rm_code,
          })
        );

        setExistingIngredients(filteredDetails);
      } catch (error) {
        if (error.response) {
          console.error("Failed to fetch existing ingredients",);
        } else if (error.request) {
          console.error("Network error",);
        } else {
          console.log("Internal server error");
        }
      }
    };
    const fetchAllInfo = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URI}/elixir/all-info`,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            withCredentials: true,
          }
        );

        if (res.status === 200) {
          setSymbolData(res.data.symbols);
        }

      } catch (error) {
        console.error("Unable to fetch details");
      }
    };
    fetchAllInfo();
    fetchExistingIngredient();
  }, []);

  // useEffect(() => {
  //   // Sync ingredientNameState with initial ingredients
  //   const names = ingredients.map((ing) => ing.ingredientName || "");
  //   setIngredientNameState(names);
  // }, [ingredients]);

  const createSymbolRegex = (symbols) => {
    const escapedSymbols = symbols
      .filter((s) => s.symbol.length > 1 || /[^\d]/.test(s.symbol)) // Exclude pure digits like "0"
      .map((s) => s.symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
    // .map((s) =>
    //   s.symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    // );
    return new RegExp(escapedSymbols.join("|"), "g"); //TM|C|0
  };

  const sanitizeHtmlContent = (html, symbolRegex) => {
    return html
      .replace(/<span\s+class=["']ql_cursor["']\s*><\/span>/g, "") // Remove cursor spans
      .replace(/[\u00A0\u200B\uFEFF]/g, "") // Remove invisible spaces
      .replace(new RegExp(`\\s+(?=${symbolRegex.source})`, "g"), ""); // Remove space before symbol
  };

  const quillRefs = useRef([]);
  const handleSymbolChange = (symbolObj, index) => {
    // setSelectedSymbols((prevSelected) => {
    //   const isSelected = prevSelected.some(
    //     (s) => s.symbol_id === symbolObj.symbol_id
    //   );

    //   const updatedIngredients = [...ingredients];
    //   const updatedNames = [...ingredientNameState];

    //   const quillInstance = quillRefs.current[index]?.getEditor();
    //   if (!quillInstance) return prevSelected;

    //   // Get current plain text (not HTML or Delta)
    //   const plainText = quillInstance.getText().trim();

    //   // Remove all known symbols from plain text
    //   let newText = plainText.replace(createSymbolRegex(symbolData), "").trim();

    //   // Add new symbol if it's not already selected
    //   if (!isSelected) {
    //     const rawCode = symbolObj?.symbol_code;
    //     const codePoint = parseInt(rawCode, 16);

    //     if (Number.isInteger(codePoint) && codePoint > 0) {
    //       const char = String.fromCodePoint(codePoint);
    //       // console.log("✅ Inserting:", char, "from hex:", rawCode);
    //       newText = `${newText}${char}`.trim();
    //     } else {
    //       console.warn("⚠️ Invalid hex symbol_code:", rawCode);
    //     }
    //   }

    //   // Replace entire Quill content (this will remove formatting, so see note below)
    //   quillInstance.setText(newText);
    //   // Clean and update product name
    //   const rawHTML = quillInstance.root.innerHTML;
    //   const cleanHTML = sanitizeHtmlContent(
    //     rawHTML,
    //     createSymbolRegex(symbolData)
    //   );

    //   updatedIngredients[index].ingredientName = cleanHTML;
    //   updatedNames[index] = cleanHTML;

    //   setIngredients(updatedIngredients);
    //   setIngredientNameState(updatedNames);

    //   return isSelected
    //     ? [{ symbol: "0", symbol_code: "0000", symbol_id: 0 }]
    //     : [symbolObj];
    // });

    const quillInstance = quillRefs.current[index]?.getEditor();
    if (!quillInstance) return;

    quillInstance.focus();
    const selection = quillInstance.getSelection();
    if (!selection) return;

    const isSelected = selectedSymbols.some(
      (s) => s.symbol_id === symbolObj.symbol_id
    );

    const updatedIngredients = [...ingredients];
    const updatedNames = [...ingredientNameState];

    const rawCode = symbolObj?.symbol_code;
    const codePoint = parseInt(rawCode, 16);

    if (!Number.isInteger(codePoint) || codePoint <= 0) {
      console.warn("⚠️ Invalid hex symbol_code:", rawCode);
      return;
    }

    const char = String.fromCodePoint(codePoint);
    setIsInsertingSymbol(true);

    if (!isSelected) {
      // Select new symbol
      setSelectedSymbols([symbolObj]);

      // Remove previous symbols and trailing newline
      let fullText = quillInstance.getText();
      if (fullText.endsWith("\n")) fullText = fullText.slice(0, -1);
      const textWithoutSymbols = fullText
        .replace(createSymbolRegex(symbolData), "")
        .trim();

      quillInstance.setText(textWithoutSymbols);

      // Insert new symbol at cursor
      const rawCode = symbolObj?.symbol_code;
      const codePoint = parseInt(rawCode, 16);
      if (!Number.isInteger(codePoint) || codePoint <= 0) {
        console.warn("Invalid hex symbol_code:", rawCode);
        setIsInsertingSymbol(false);
        return;
      }
      const char = String.fromCodePoint(codePoint);
      let cursorIndex = Math.min(selection.index, textWithoutSymbols.length);
      quillInstance.insertText(cursorIndex, char, "user");
      quillInstance.setSelection(cursorIndex); // Cursor before symbol

      // Update ingredient name
      const rawHTML = quillInstance.root.innerHTML;
      const cleanHTML = sanitizeHtmlContent(
        rawHTML,
        createSymbolRegex(symbolData)
      );
      updatedIngredients[index].ingredientName = cleanHTML;
      updatedNames[index] = cleanHTML;
      setIngredients(updatedIngredients);
      setIngredientNameState(updatedNames);
      setIsInsertingSymbol(false); // Done inserting
    } else {
      // If the symbol is already selected, deselect it and remove it
      setSelectedSymbols([{ symbol: "0", symbol_code: "0000", symbol_id: 0 }]);

      // Remove existing symbol
      let fullText = quillInstance.getText();
      if (fullText.endsWith("\n")) fullText = fullText.slice(0, -1);
      const textWithoutSymbols = fullText
        .replace(createSymbolRegex(symbolData), "")
        .trim();

      quillInstance.setText(textWithoutSymbols);

      // Update ingredient name
      const rawHTML = quillInstance.root.innerHTML;
      const cleanHTML = sanitizeHtmlContent(
        rawHTML,
        createSymbolRegex(symbolData)
      );
      updatedIngredients[index].ingredientName = cleanHTML;
      updatedNames[index] = cleanHTML;
      setIngredients(updatedIngredients);
      setIngredientNameState(updatedNames);
    }

    setIsInsertingSymbol(false);

    isSelected
      ? setSelectedSymbols([{ symbol: "0", symbol_code: "0000", symbol_id: 0 }])
      : setSelectedSymbols([symbolObj]);
  };

  const getPlainTextFromQuill = (htmlContent) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlContent;
    return tempElement.textContent || tempElement.innerText || "";
  };

  const handleIngredientNameChange = (htmlContent, index) => {
    if (isInsertingSymbol) {
      return;
    }

    const placeholderSymbol = { symbol: "0", symbol_code: "0000", symbol_id: 0 };

    // Step 1: Remove invisible characters and ql_cursor spans
    let cleanedHtml = htmlContent
      .replace(/<span\s+class=["']ql_cursor["']\s*><\/span>/g, "")
      .replace(/[\u00A0\u200B\uFEFF]/g, "")
      .replace(/\s+(?=(${createSymbolRegex(symbolData).source}))/g, ""); // Remove space before symbols

    const plainText = getPlainTextFromQuill(cleanedHtml).trim();

    const symbolMatch = plainText.match(createSymbolRegex(symbolData));
    const updatedNames = [...ingredientNameState];
    const updatedIngredients = [...ingredients];

    // Update ingredient name
    updatedIngredients[index].ingredientName = cleanedHtml;
    updatedNames[index] = cleanedHtml;
    setIngredients(updatedIngredients);
    setIngredientNameState(updatedNames);

    // Update selectedSymbols based on text content
 
  if (symbolMatch) {
    const foundSymbol = symbolData.find(
      (symbolObj) => symbolMatch[0] === symbolObj.symbol
    );
    if (
      foundSymbol &&
      foundSymbol.symbol_id !== selectedSymbols[0]?.symbol_id
    ) {
      setSelectedSymbols([foundSymbol]);
    }
  } else if (selectedSymbols[0]?.symbol_id !== placeholderSymbol.symbol_id) {
    setSelectedSymbols([placeholderSymbol]);
  }

    if (selectedSymbols) {
      const symbolPresent = selectedSymbols.some((symbolObj) =>
        plainText.includes(symbolObj.symbol)
      );
      if (symbolPresent === -1) {
        setSelectedSymbols([
          { symbol: "0", symbol_code: "0000", symbol_id: 0 },
        ]);
      }
    }

    // if (selectedSymbols && symbolMatch) {
    //   const symbolStartIndex = plainText.indexOf(symbolMatch[0]);
    //   if (
    //     symbolStartIndex !== -1 &&
    //     symbolStartIndex + symbolMatch[0].length < plainText.length
    //   ) {
    //     const cleanInput = plainText
    //       .replace(createSymbolRegex(symbolData), "")
    //       .trim();
    //     setSelectedSymbols([
    //       { symbol: "0", symbol_code: "0000", symbol_id: 0 },
    //     ]);
    //     updatedNames[index] = cleanedHtml;
    //     updatedIngredients[index].ingredientName = cleanedHtml;
    //   } else {
    //     updatedNames[index] = cleanedHtml;
    //     updatedIngredients[index].ingredientName = cleanedHtml;
    //   }
    // } else {
    //   updatedNames[index] = cleanedHtml;
    //   updatedIngredients[index].ingredientName = cleanedHtml;
    // }

    // setIngredientNameState(updatedNames);
    // setIngredients(updatedIngredients);
    // const updatedNames = [...ingredientNameState];
    // const updatedIngredients = [...ingredients];

    // updatedNames[index] = text;
    // updatedIngredients[index].ingredientName = text;

    // setIngredientNameState(updatedNames);
    // setIngredients(updatedIngredients);
  };

  // Handle ingredient field changes
  const handleIngredientChange = (index, eventOrValue, fieldName) => {
    const values = [...ingredients];
    const nameUpdates = [...ingredientNameState];

    if (typeof eventOrValue === "string" && fieldName === "ingredientName") {
      // ReactQuill case
      values[index][fieldName] = eventOrValue;
      nameUpdates[index] = eventOrValue;
    } else {
      // Regular input case
      const { name, value } = eventOrValue.target;
      values[index][name] = value;
      if (name === "ingredientName") {
        nameUpdates[index] = value;
      }
    }

    setIngredients(values);
    setIngredientNameState(nameUpdates);
  };

  // const [isOpen, setIsOpen ] = useModal();
  const { openModal } = useModal();
  const handleClick = (e) => {
    openModal(<SymbolForm />);
  };

  const handleNutritionChange = (event) => {
    setNutrition((prevNutrition) => ({
      ...prevNutrition,
      [event.target.name]: event.target.value,
    }));
  };

  // Handle changes for column values
  const handleColumnValueChange = (event) => {
    setColumnValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  // Handle changes for attribute details
  const handleAttributeDetailsChange = useCallback((event) => {
    if (event.target.name === "Source") {
    }
    setAttributeDetails((prevDetails) => ({
      ...prevDetails,
      [event.target.name]: event.target.value,
    }));
  }, []);

  // Handle allergen dropdown changes
  const handleAllergenChange = (event) => {
    setAllergens((prevAllergens) => ({
      ...prevAllergens,
      [event.target.name]: event.target.value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    // Define the payloads to match the cURL request format
    let isValid = true;
    if (
      !nutrition.ash ||
      !nutrition.calories ||
      !nutrition.carbohydrates ||
      !nutrition.fat ||
      !nutrition.moisture ||
      !nutrition.protein
    ) {
      isValid = false;
      toast.error("Please fill all details and try again");
    }
    if (!isValid) {
      isValid = true;
      return;
    }

    const payload = {
      data: {
        ingredient_item_code: ingredients[0].itemCode.toUpperCase().trim(),
        ingredient_name: ingredients[0].ingredientName,
        symbol_id: selectedSymbols[0].symbol_id,
        vendor: ingredients[0].vendorName.trim(),
        rm_code: ingredients[0].rmCode.toUpperCase().trim(),
        cas_number: attributeDetails["cas Number"].trim(),
        ec_number: attributeDetails["ec Number"].trim(),
        ingredient_type: "string".trim(), //Ingredient Type
        source_type: attributeDetails["Source Type"].trim(),
        source: attributeDetails.source.trim(),
        country_of_origin: attributeDetails.country.trim(),
        calories: nutrition.calories,
        fat: nutrition.fat,
        carbohydrates: nutrition.carbohydrates,
        protein: nutrition.protein,
        moisture: nutrition.moisture,
        ash: nutrition.ash,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      },
      data1: {
        ing_item_code: columnValues.ing_item_code.trim(),
        rm_code: columnValues.rm_code.trim(),
        vegetarian: columnValues.vegetarian.trim(),
        vegan: columnValues.vegan.trim(),
        non_gmo: columnValues.non_gmo.trim(),
        classification: columnValues.classification.trim(),
        gluten_status: columnValues.gluten_status.trim(),
        bse_tse: columnValues.bse_tse.trim(),
        declared_allergen: "string".trim(), //declared allergen
        wheat: allergens.wheat.trim(),
        eggs: allergens.eggs.trim(),
        crustaceans_shell_fish: allergens.crustaceans_shell_fish.trim(),
        fish: allergens.fish.trim(),
        milk: allergens.milk.trim(),
        tree_nuts: allergens.tree_nuts.trim(),
        peanuts: allergens.peanuts.trim(),
        soy: allergens.soy.trim(),
        sesame_seeds: allergens.sesame_seeds.trim(),
        celery: allergens.celery.trim(),
        barley_oats_rye_spelt: allergens.barley_oats_rye_spelt.trim(),
        orange_kiwi_peaches_apples: allergens.orange_kiwi_peaches_apples.trim(),
        mushrooms: allergens.mushrooms.trim(),
        mustard: allergens.mustard.trim(),
        lupin: allergens.lupin.trim(),
        molluscs: allergens.molluscs.trim(),
        sulfur: allergens.sulfur.trim(),
        allergen_fermentation: "string".trim(), //allergen fermentation
        residual_solvent: columnValues.residual_solvent.trim(),
        wada_compliance: columnValues.wada_compliance.trim(),
        eto_treated: columnValues.eto_treated.trim(),
        irradiated: columnValues.irradiated.trim(),
        sewage_sludge_treated: columnValues.sewage_sludge_treated.trim(),
        pesticide: columnValues.pesticide.trim(),
        aflatoxin: columnValues.aflatoxin.trim(),
        preservative: columnValues.preservative.trim(),
        antibiotic: columnValues.antibiotic.trim(),
        gras: columnValues.gras.trim(),
        prop65_complaint: columnValues.prop65_complaint.trim(),
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      },
    };

    try {
      // Send combined data payload
      event.preventDefault();

      await axios.post(
        `${process.env.REACT_APP_BASE_URI}/elixir/raw_material`,
        payload,
        {
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Data submitted successfully!");
      setTimeout(() => {
        navigate("/database/ingredient");
      }, 3000);
    } catch (error) {
      console.error("Error submitting data:", error.response || error.message);

      if (error.response) {
        // Handle server response errors
        toast.error(
          `Server Error: ${
            error.response.data?.message || "Submission failed."
          }`
        );
      } else if (error.message.includes("Network Error")) {
        // Handle network errors
        toast.error("Network Error! Please check your internet connection.");
      } else {
        // Handle other errors
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  // Pagination: Go to the next step
  const nextStep = () => {
    if (currentStep < 6) {
      let isValid = true;

      if (currentStep === 1) {
        // Assuming multiple ingredients, check all for valid itemCode and rmCode
        ingredients.forEach((ingredient) => {
          // const match = existingIngredients.find((ing) => ing.ing_item_code === ingredient.itemCode);

          // if (match) {
          //   if (ingredient.rmCode === match.rm_code) {
          //     isValid = false;
          //     toast.error("Vendor already exists for this ingredient.");
          //     return; // Stop further checking for this ingredient

          //   } else if (  ingredient.ingredientName !== match.ing_name) {
          //     isValid = false;
          //     toast.error("Please check ingredient name for existing item code!");
          //     return; // Stop further checking for this ingredient
          //   }
          // }

          // ingredient.ingredientName !== match.ing_name

          // Check if itemCode and rmCode are provided
          if (!ingredient.itemCode || !ingredient.rmCode) {
            isValid = false;
            toast.error(
              "Item Code and RM Code must be filled for all ingredients!"
            );
          } else if (
            ingredient.itemCode.length > 15 ||
            ingredient.rmCode.length > 15
          ) {
            isValid = false;
            toast.error("Item Code and RM Code cannot exceed 15 characters!");
          }
        });

        if (!isValid) return; // Stop execution if validation failed

        // Collect itemCode and rmCode for all ingredients if valid
        const itemCodes = ingredients
          .map((ingredient) => ingredient.itemCode)
          .join(", ");
        const rmCodes = ingredients
          .map((ingredient) => ingredient.rmCode)
          .join(", ");

        // Set columnValues with the collected codes
        setColumnValues((prevValues) => ({
          ...prevValues,
          ing_item_code: itemCodes,
          rm_code: rmCodes,
        }));
      } else if (currentStep === 2) {
        if (
          !columnValues.aflatoxin ||
          !columnValues.antibiotic ||
          !columnValues.bse_tse ||
          !columnValues.classification ||
          !columnValues.eto_treated ||
          !columnValues.gluten_status ||
          !columnValues.gras ||
          !columnValues.irradiated ||
          !columnValues.non_gmo ||
          !columnValues.pesticide ||
          !columnValues.preservative ||
          !columnValues.prop65_complaint ||
          !columnValues.residual_solvent ||
          !columnValues.sewage_sludge_treated ||
          !columnValues.vegan ||
          !columnValues.vegetarian ||
          !columnValues.wada_compliance
        ) {
          isValid = false;
          toast.error("Please fill all details");
        }
        if (!isValid) {
          isValid = true;
          return;
        }
      } else if (currentStep === 3) {
        if (
          !allergens.barley_oats_rye_spelt ||
          !allergens.celery ||
          !allergens.crustaceans_shell_fish ||
          !allergens.eggs ||
          !allergens.fish ||
          !allergens.lupin ||
          !allergens.milk ||
          !allergens.molluscs ||
          !allergens.mushrooms ||
          !allergens.mustard ||
          !allergens.orange_kiwi_peaches_apples ||
          !allergens.peanuts ||
          !allergens.sesame_seeds ||
          !allergens.soy ||
          !allergens.tree_nuts ||
          !allergens.wheat
        ) {
          isValid = false;
          toast.error("Please fill all details");
        }
        if (!isValid) {
          isValid = true;
          return;
        }
      } else if (currentStep === 4) {
        if (
          !attributeDetails["Source Type"] ||
          !attributeDetails.country ||
          !attributeDetails.source
        ) {
          isValid = false;
          toast.error("Please fill all details");
        }
        if (!isValid) {
          isValid = true;
          return;
        }
      }
      // Move to the next step
      setCurrentStep(currentStep + 1);
    }
  };

  // Pagination: Go to the previous step
  const previousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handledb = () => {
    navigate("/database");
  };

  return (
    <div className="bg-gray-900 w-full min-h-screen text-gray-200 p-8">
      <nav className="navbar bg-gray-800 text-white p-4 flex justify-between">
        <h1 className="text-2xl font-bold">Ingredient Database</h1>
        <div className="relative">
          <button
            className="text-white font-bold py-2 px-4 rounded"
            title="Settings"
            onClick={toggleDropdown}
          >
            <FaCog />
          </button>
          {dropdownOpen && (
            <div className="absolute right-0 mt-2 bg-gray-900 text-white rounded shadow-lg p-2 w-48">
              <ul>
                <li
                  onClick={handledb}
                  className="py-1 cursor-pointer hover:bg-gray-700"
                >
                  Database
                </li>
              </ul>
            </div>
          )}
        </div>
      </nav>

      <div className="p-8 bg-gray-800 rounded-lg mt-6 space-y-6 flex flex-col">
        <div>
          <button
            onClick={() => {
              navigate('/database/ingredient');
            }}
            type="button"
            class="bg-gray-900 mb-6 relative top left-0 text-white py-2 px-4 rounded shadow "
          >
            Back To Ingredients
          </button>
        </div>

        <h2 className="text-xl font-bold mb-4">Step {currentStep}</h2>

        {/* Step 1: Ingredient Information */}
        {currentStep === 1 && (
          <>
            <form className="space-y-10 max-sm:w-full flex justify-center">
              {ingredients.map((ingredient, index) => (
                <div
                  key={index}
                  className="flex p-10 border bg-gray-700 rounded-lg items-center max-w-full w-full sm:w-3/4 justify-center grid grid-cols-1 gap-4"
                >
                  <h1 className="text-xl font-bold mb-4 sm:text-center">
                    Ingredients Information
                  </h1>
                  {/* Ingredient Name Section */}
                  <div className="flex justify-center items-center grid grid-cols-1 sm:grid-cols-[30%,70%]  space-y-3">
                    <label className="font-semibold sm:text-center">
                      Ingredient Name
                    </label>

                    {/* Text Editor */}
                    <div className="flex flex-col items-center w-full sm:w-full">
                      <div className="w-full">
                        <ReactQuill
                          ref={(el) => (quillRefs.current[index] = el)}
                          name="ingredientName"
                          value={ingredientNameState[index] || ""}
                          onChange={(content) =>
                            handleIngredientNameChange(content.trim(), index)
                          }
                          theme="snow"
                          className=" text-gray-200 w-full"
                          required
                        />
                      </div>

                      {/* Symbol Selection */}
                      <div className="flex self-start mx-2 flex-wrap gap-4 my-2">
                        {symbolData.length > 0 ? (
                          symbolData
                            .filter((item) => item.symbol_id !== 0)
                            .map((symbolObj) => (
                              <label
                                key={symbolObj.symbol_id}
                                className="flex items-center space-x-2"
                              >
                                <input
                                  type="checkbox"
                                  name="symbol"
                                  checked={selectedSymbols.some(
                                    (selected) =>
                                      selected.symbol_id === symbolObj.symbol_id
                                  )}
                                  onChange={() =>
                                    handleSymbolChange(symbolObj, index)
                                  }
                                  className="rounded-[100%] appearance-none color-white w-3 h-3 bg-white checked:bg-blue-500"
                                />
                                <span className="text-xl">
                                  {symbolObj.symbol}
                                </span>
                              </label>
                            ))
                        ) : (
                          <p className="text-gray-400">No symbols available</p>
                        )}
                        <button
                          type="button"
                          onClick={() => handleClick()}
                          className="bg-blue-500 w-10 rounded-full mt-1"
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Item Code Section */}
                  <div className="flex justify-center items-center grid grid-cols-1 sm:grid-cols-[30%,70%] w-full space-y-3">
                    <label className="font-semibold sm:text-center">
                      Item Code
                    </label>
                    <input
                      type="text"
                      name="itemCode"
                      value={ingredient.itemCode}
                      onChange={(event) => handleIngredientChange(index, event)}
                      maxLength={15}
                      className="border border-gray-400 rounded px-4 py-2 bg-gray-600 text-gray-200"
                      placeholder="Enter Item Code"
                      required
                    />
                  </div>

                  {/* Vendor Name Section */}
                  <div className="flex justify-center items-center grid grid-cols-1 sm:grid-cols-[30%,70%] w-full space-y-3">
                    <label className="font-semibold sm:text-center">
                      Vendor Name
                    </label>
                    <input
                      type="text"
                      name="vendorName"
                      value={ingredient.vendorName}
                      onChange={(event) => handleIngredientChange(index, event)}
                      className="border border-gray-400 rounded px-4 py-2 bg-gray-600 text-gray-200"
                      placeholder="Enter Vendor Name"
                      required
                    />
                  </div>

                  {/* RM Code Section */}
                  <div className="flex justify-center items-center grid grid-cols-1 sm:grid-cols-[30%,70%] w-full space-y-3">
                    <label className="font-semibold sm:text-center">
                      RM Code
                    </label>
                    <input
                      type="text"
                      name="rmCode"
                      value={ingredient.rmCode}
                      onChange={(event) => handleIngredientChange(index, event)}
                      maxLength={15}
                      className="border border-gray-400 rounded px-4 py-2 bg-gray-600 text-gray-200"
                      placeholder="RM-XXX-XXX"
                      required
                    />
                  </div>
                </div>
              ))}
            </form>

            {/* <div className="w-full max-w-2xl my-7 space-y-3 overflow-auto">
              <h2 className="text-xl font-semibold sm:text-center text-white">
                Ingredient Details
              </h2>
              <table className="w-full table-auto bg-gray-700 text-gray-200 rounded-lg text-center ">
                <thead>
                  <tr>
                    <th className="px-4 py-2 text-center">Item Attributes</th>
                    <th className="px-4 py-2 text-center">Value</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(attributeDetails).map((attributeName, index) => (
                    <tr
                      key={index}
                      className="border-t border-gray-600 text-center"
                    >
                      <td className="px-4 py-2 capitalize text-center">
                        {attributeName}
                      </td>
                      <td className="px-4 py-2 text-center ">
                        <div className="flex justify-center">
                          {renderComponent(
                            attributeName,
                            attributeDetails[attributeName],
                            handleAttributeDetailsChange
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div> */}
          </>
        )}

        {/* Step 2: Declaration */}
        {currentStep === 2 && (
          <Declaration
            columnValues={columnValues}
            handleColumnValueChange={handleColumnValueChange}
            className="w-1/2"
          />
        )}

        {/* Step 3: Allergen Selection */}
        {currentStep === 3 && (
          <AllergenSelection
            allergens={allergens}
            handleAllergenChange={handleAllergenChange}
          />
        )}

        {/* Step 4: Attributes */}
        {currentStep === 4 && (
          <Attributes
            attributeDetails={attributeDetails}
            handleAttributeDetailsChange={handleAttributeDetailsChange}
            setSourceTypeOther={setSourceTypeOther}
            setCountryOther={setCountryOther}
            sourceTypeOther={sourceTypeOther}
            countryOther={countryOther}
            className="w-1/2"
          />
        )}

        {currentStep === 5 && (
          <Nutrition
            nutrition={nutrition}
            handleNutritionChange={handleNutritionChange}
          />
        )}

        {/* Pagination Controls */}
        <div className="flex justify-between mt-4">
          {currentStep > 1 && (
            <button
              onClick={previousStep}
              className="bg-gray-700 text-white px-4 py-2 rounded"
            >
              Previous
            </button>
          )}
          {currentStep < 5 && (
            <button
              onClick={nextStep}
              className="bg-blue-600 text-white px-4 py-2 rounded"
            >
              Next
            </button>
          )}
          {currentStep === 5 && (
            <button
              onClick={handleSubmit}
              className="bg-green-600 text-white px-4 py-2 rounded"
            >
              Submit
            </button>
          )}
        </div>
      </div>
      <ToastContainer theme="dark" />
    </div>
  );
};

export default IngredientDBForm;
